export enum EditControlSource {
    MANAGE_DONE = 'manageDone',
    MANAGE_ACTIVE = 'manageActive',
    MANAGE_PLANNED = 'managePlanned'
}